// The project service pages (src/components/ProjectServicePage.js), one data
// file each. gatsby-config (sitemap lastmod) and the canonical filter read
// `projectServices` for their paths and reviewed dates.
const architectural = require('./architectural-3d-printing')
const art = require('./art-fabrication')
const artLosAngeles = require('./sculpture-los-angeles')
const plating = require('./metal-plating')
const signs3d = require('./3d-signs-nyc')
const neon = require('./neon-signs-nyc')

const projectServicePages = {
  architectural,
  art,
  artLosAngeles,
  plating,
  signs3d,
  neon,
}

const projectServices = Object.values(projectServicePages)

module.exports = { projectServicePages, projectServices }
